import React from "react";
import { useEffect, useState } from "react";
import axiosAdmin from "../../../../api/apiAdmin";
import PaginatedItems from "../../Pagination/Pagination";
import { successToast, errorToast } from "../../toastAlerts/ToastAlerts";
import PanelMessageCard from "./PanelMessageCard";
import { TextAreaInput, TextInput } from "../../inputComponents/inputcomp";
import { useTranslation } from "react-i18next";
import { apiError } from "../../../../api/apiError";
import DirectSendPanel from "./DirectSendPanel";
import BulkSendPanel from "./BulkSendPanel";

const PanelMessages = () => {
  const { t } = useTranslation();
  //messeges
  const [messageData, setMessageData] = useState([]);
  //data amount
  const [total, setTotal] = useState(0);
  //current page
  const [currentPage, setCurrentPage] = useState(0);
  //affect data change depended on delete and add responses
  const [difResponses, setDifResponses] = useState(null);
  //message type 1 = income 2 = replay from me
  const [type, setType] = useState(1);
  //global message
  const [globalMsg, setGlobalMsg] = useState({});
  const [privateMsg, setPrivateMsg] = useState({});

  const handlePrivateMsg = (value, key) => {
    setPrivateMsg((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleGlobalMsg = (value, key) => {
    setGlobalMsg({
      [key]: value,
    });
  };

  useEffect(() => {
    axiosAdmin
      .get(`/message?type=${type}&per_page=12&page=${currentPage + 1}`)
      .then(({ data }) => {
        setMessageData(data.data);
        setTotal(data.total);
      });
  }, [difResponses, type]);

  //delete massage
  const handleDelete = async (id) => {
    try {
      const res = await axiosAdmin.delete(`/message/${id}`);
      setDifResponses(res);
      if (res) {
        successToast(t("admin_deleted_success"));
      }
    } catch (error) {
      errorToast(apiError(error, t("admin_error")));
    }
  };

  //handle send msg
  const handleSendGlobalMsg = () => {
    axiosAdmin
      .post(`/sendMails`, {
        text: globalMsg.msg,
      })
      .then((res) => {
        successToast(t("admin_sent_success"));
      })
      .catch((err) => {
        errorToast(t("admin_error"));
      });
  };

  const handleSendPrivateMsg = () => {
    axiosAdmin
      .post(`/snendSMS`, {
        text: privateMsg.text,
        phone: privateMsg.phone,
      })
      .then((res) => {
        successToast(t("admin_sent_success"));
      })
      .catch((err) => {
        errorToast(t("admin_error"));
      });
  };

  return (
    <div
      className="xl:ml-[280px] mt-[55px] bg-slate-100 dark:bg-slate-900 
        min-h-screen p-10 sm:p-5 pb-24 sm:pb-24"
    >
      {/* Direct email / SMS with the provider's answer, plus the send log. */}
      <div className="mb-6">
        <DirectSendPanel />
      </div>

      {/* Mass send to an audience picked by parcel state. */}
      <div className="mb-6">
        <BulkSendPanel />
      </div>

      <div className="flex items-center gap-2 mb-5">
        <div
          className={`px-2 py-3 rounded-lg shadow-md border border-gray-300
                            ${
                              type === 1 ? "bg-green-300" : "bg-white"
                            } cursor-pointer`}
          onClick={() => {
            setType(1);
          }}
        >
          <p
            className={`text-sm font-bold text-slate-500 ${
              type === 1 && "text-white"
            }`}
          >
            {t("admin_inbox")}
          </p>
        </div>
        <div
          className={`px-2 py-3 rounded-lg shadow-md border border-gray-300
                            ${
                              type === 2 ? "bg-green-300" : "bg-white"
                            } cursor-pointer`}
          onClick={() => {
            setType(2);
          }}
        >
          <p
            className={`text-sm font-bold text-slate-500 ${
              type === 2 && "text-white"
            }`}
          >
            {t("admin_sent_messages")}
          </p>
        </div>
      </div>

      <h1>{t("admin_send_global_message")}</h1>

      <div className="mb-3">
        <TextAreaInput
          name={t("admin_message")}
          inputName={"msg"}
          inputSetter={handleGlobalMsg}
        />
        <div className="mt-3">
          <button
            onClick={handleSendGlobalMsg}
            className="bg-green-500 rounded-lg px-4 py-2 text-white"
          >
            {t("admin_send")}
          </button>
        </div>
      </div>
      <h1>{t("admin_send_personal_message")}</h1>
      <div className="mb-3">
        <TextInput
          name={t("admin_number")}
          inputName={"phone"}
          inputSetter={handlePrivateMsg}
        />
        <TextAreaInput
          name={t("admin_message")}
          inputName={"text"}
          inputSetter={handlePrivateMsg}
        />
        <div className="mt-3">
          <button
            onClick={handleSendPrivateMsg}
            className="bg-green-500 rounded-lg px-4 py-2 text-white"
          >
            {t("admin_send")}
          </button>
        </div>
      </div>
      <div>
        <PaginatedItems
          pageNumberSetter={setCurrentPage}
          itemsPerPage={12}
          dataLength={total}
        >
          <div className="w-full flex flex-col gap-2 my-5">
            {messageData.map((item) => {
              return (
                <PanelMessageCard
                  key={item.id}
                  item={item}
                  handleDelete={handleDelete}
                  type={type}
                  setDifResponses={setDifResponses}
                />
              );
            })}
          </div>
        </PaginatedItems>
      </div>
    </div>
  );
};

export default PanelMessages;
